import i18n from '@/plugins/vue-i18n';
import { getWorkpackageScenarioFromRoute } from '@/utils/scenario-from-route';

// The page AO is showing, for the browser tab: the sub-page and the scenario it is under, without the
// product name — standalone AO prefixes that itself, and embedded the shell adds it - ADR-018 - https://github.com/owg-digital/rtls-one-retail/tree/main/frontend/shell/docs/adrs/018-shell-owns-the-tab-title.md
// Empty while nothing has resolved. Call inside an active pinia context.
// `waitForScenario` holds the whole detail back until a scenario route has its name, so a reporter
// that re-reports on every store change settles once instead of flashing the page name alone.
export function getTabTitleDetailFromRoute(route, { waitForScenario = false } = {}) {
  const { scenario } = getWorkpackageScenarioFromRoute(route);
  if (waitForScenario && route?.params?.scenarioId && !scenario) return '';
  const titleExtension = route?.meta?.titleExtension;
  return [titleExtension && i18n.t(titleExtension), scenario?.name].filter(Boolean).join(' | ');
}
